import { render, staticRenderFns } from "./btn-prio.vue?vue&type=template&id=693b5d5a"
import script from "./btn-prio.vue?vue&type=script&lang=js"
export * from "./btn-prio.vue?vue&type=script&lang=js"
import style0 from "./btn-prio.vue?vue&type=style&index=0&id=693b5d5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports